import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ClientContactService } from 'src/app/services/client-contact.service';
import { ClientService } from 'src/app/services/client.service';
import { LimosService } from 'src/app/services/limos.service';
import { AppUtils } from 'src/app/utilities/app.utils';
import { SortDirection } from '../../providers/providers.component';

@Component({
  selector: 'app-client-contact',
  templateUrl: './client-contact.component.html',
  styleUrls: ['./client-contact.component.scss']
})
export class ClientContactComponent implements OnInit, OnDestroy {
  invoicePage = 1;
  invoiceLimit = 30;
  invoiceTotal: number;
  @BlockUI('invoice-list')
  invoiceListBlockUI: NgBlockUI;
  private unsubscribe$ = new Subject<void>();
  invoiceListOrderBy = 'id';
  invoiceListOrderDirection: SortDirection = 'asc';
  addClientContactForm:FormGroup;
  clientContacts: any;
  clientLocations = [];

  constructor(
    private limosService: LimosService,
    private appUtils: AppUtils,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private modalService:NgbModal,
    private clientContactService: ClientContactService,
    private clientService: ClientService
  ) {}

  ngOnInit() {
    this.getClientContact();
    this.initClientContactForm();
  }

  initClientContactForm(){
    this.addClientContactForm = this.fb.group({
      client: new FormControl(''),
      username: new FormControl(''),
      password: new FormControl(''),
      first_name: new FormControl(''),
      last_name: new FormControl(''),
      dob: new FormControl(''),
      title: new FormControl(''),
      email: new FormControl(''),
      work_phone: new FormControl(''),
      mobile_phone: new FormControl(''),
      general_notes: new FormControl(''),
      program_name : new FormControl(''),
    });
  }

  getClientContact() {
    this.invoiceListBlockUI.start();

    const filterBy = this.activatedRoute.snapshot.params['limos_id'] || '';

    const $invoiceList = this.clientContactService.getClientContacts(
      this.invoiceLimit,
      this.invoicePage
    );

    $invoiceList.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (resp:any) => {
        const { hits, estimatedTotalHits } = resp.details;

        this.invoiceTotal = estimatedTotalHits;
        this.clientContacts = hits;
        this.invoiceListBlockUI.stop();
      },
      (error) => {
        console.error('Error fetching invoices:', error);
        this.invoiceListBlockUI.stop();
      }
    );
  }

  onPageChangeinvoices(event: any) {
    this.invoicePage = event;
    this.getClientContact();
  }

  onSizeChangeinvoices(limit: number) {
    this.invoiceLimit = limit;
    this.invoicePage = 1;
    this.getClientContact();
  }

  sortColumn(column: string) {
    this.invoiceListOrderBy = column;
    this.invoiceListOrderDirection =
      this.invoiceListOrderDirection === 'asc' ? 'desc' : 'asc';
    this.getClientContact();
  }

  openPopup(content, size = 'md',service=this.modalService) {
    service.open(content, {
      ariaDescribedBy: 'modal-basic-title',
      windowClass: 'groupModal',
      size,
      centered: true,
    });
  }

  searchClient$ = (term: string): Observable<any[]> =>{
    return this.clientService.fetchClients(10, 1, term).pipe(
      map((res) => res?.details?.hits || [])
    );
  }

  onChangeClient(clientId:number){
    this.getClientLocation(clientId);
  }

  getClientLocation(clientId: number) {
    this.clientService
      .fetchClientLocations(clientId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.clientLocations = res?.hits || [];
      });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
